import { useCallback } from "react"
import { initializeErrors } from "../reducer/validationSlice"
import { useValidateRepeatableElement } from "./useValidateRepeatableElement"
import validate  from "validate.js"
import { createValidationStructure } from "../../../../src/components/Helper"
import { isObject } from "../util/typeCheck"


export const useInitializerTransportValidations = (tabName,validationPattern,translate) => {

  const keys = {
    activeTransportMeansList:translate('ACTIVE_TRANS_MEANS'),
    departureTransportMeansList:translate('DEPARTURE_TRANSPORT_MEANS'),
   }

    const repeatableValidationMethodsTransport=useValidateRepeatableElement(tabName,validationPattern,translate)
    const initTransportTabValidation = useCallback(() => (dispatch, getState) => {
     
            const transportTab = getState().transportReducer
            const fieldPatternTransportTab = validationPattern({qualifierId:transportTab?.locationOfGoods?.qualifierId,inlandTransportMode:transportTab?.inlandTransportMode})?.[tabName]

            let errors = Object.entries(transportTab).reduce((prev,[key,value])=>{
                  if(isObject(value) && fieldPatternTransportTab[key]){
                    let error = validate({[`${key}`]:value},fieldPatternTransportTab[key]) ||{}
                         error = createValidationStructure(error)
                   
                    prev = {...prev,...error}
                  }else if(Array.isArray(value) && fieldPatternTransportTab[key]){
                    const {validateError}=repeatableValidationMethodsTransport
                    let error=dispatch(validateError("transportReducer",key,`${keys[key]}`)) || {}
                    error = Object.entries(error)?.reduce((prev, [key, val])=>val?({...prev,[key]:val }) :({...prev}),{}) // Temp solution
                         prev = {...prev,...error}
                }
                return prev;
                          
            },{}) || {}

            let error = validate({security:transportTab?.security},{security:fieldPatternTransportTab['security']}) ||{}
            error = createValidationStructure(error)
            errors={...errors,...error}
            dispatch(initializeErrors({transportTab:errors}))
    }, [validationPattern])

   

    return { initTransportTabValidation,repeatableValidationMethodsTransport}
}